import { inject, Injectable } from '@angular/core';
import { ArrayFunctions } from '@campus/utils';
import { Observable } from 'rxjs';
import { BearerHttpService } from '../bearer-http';
import { DAL_OPTIONS, DalOptions } from '../dal.module';
import { WordInterface } from '../word';
import { WordSetInterface } from './word-set.interface';
import { WordSetServiceInterface } from './word-set.service.interface';
const { wrapIntoArray } = ArrayFunctions;

@Injectable({
  providedIn: 'root',
})
export class WordSetService implements WordSetServiceInterface {
  private bearerHttpService = inject(BearerHttpService);
  private dalOptions = inject<DalOptions>(DAL_OPTIONS);
  private apiV2BaseUrl = this.dalOptions.apiV2BaseUrl;

  unlinkWord(tocEntryId: number, wordId: number): Observable<void> {
    const url = `${this.apiV2BaseUrl}/word-set/${tocEntryId}/unlink/${wordId}`;
    return this.bearerHttpService.delete<void>(url);
  }

  updateWordsForToc(tocEntryId: number, words: WordInterface[]): Observable<void> {
    const url = `${this.apiV2BaseUrl}/word-set/toc-entry/${tocEntryId}`;
    const wordIds = words.map((word) => word.id);

    return this.bearerHttpService.put<void>(url, { wordIds });
  }

  publish(wordSetId: number | number[], tocEntryId: number): Observable<void> {
    const url = `${this.apiV2BaseUrl}/word-set/publish`;
    const body = { tocEntryId, wordSetIds: wrapIntoArray(wordSetId) };
    return this.bearerHttpService.post(url, body);
  }

  unpublish(wordSetId: number | number[], tocEntryId: number): Observable<void> {
    const url = `${this.apiV2BaseUrl}/word-set/unpublish`;
    const body = { tocEntryId, wordSetIds: wrapIntoArray(wordSetId) };
    return this.bearerHttpService.post(url, body);
  }

  getWordSetForToc(tocEntryId: number): Observable<WordSetInterface> {
    const url = `${this.apiV2BaseUrl}/word-set/toc-entry/${tocEntryId}`;
    return this.bearerHttpService.get<WordSetInterface>(url);
  }

  getWordSetForPublication(publicationId: number): Observable<WordSetInterface> {
    const url = `${this.apiV2BaseUrl}/word-set/publication/${publicationId}`;
    return this.bearerHttpService.get<WordSetInterface>(url);
  }
}
